export default "__VITE_ASSET__BG4tM_mq__"